import { InMemoryCache } from '@apollo/client';
import {
  offsetLimitPagination,
  relayStylePagination,
} from '@apollo/client/utilities';

export const createCache = () =>
  new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          events: offsetLimitPagination([
            'startDateTime',
            'endDateTime',
            'category',
            'promoted',
            'isOffline',
            'settlementId',
            'areaId',
            'regionId',
            'cityId',
            'ordering',
            'specialProjectSlug',
            'speakersIds',
          ]),
          contents: offsetLimitPagination([
            'promoted',
            'category',
            'searchQuery',
            'event',
            'type',
            'ordering',
            'speakersIds',
          ]),
          tagCompilationBySlug: offsetLimitPagination([
            'slugTag',
            'limit',
            'typeTag',
          ]),
          tagCompilations: offsetLimitPagination([
            'slug',
            'limit',
            'randomize',
          ]),
          posts: offsetLimitPagination([
            'limit',
            'published',
            'slugSpecialProject',
          ]),
          speakers: offsetLimitPagination([
            'lastName',
            'leagueOfLecturersWinner',
            'season',
            'showOnMainPage',
          ]),
          contentsByMacroTag: offsetLimitPagination([
            'limit',
            'slug',
            'type',
            'describeTags',
          ]),
          contentsByMicroTags: offsetLimitPagination(['slugs', 'type']),
          tagCategory: offsetLimitPagination(['limit', 'describeTags']),
          eventsByMacroTags: offsetLimitPagination(['limit', 'slug']),
          searchSchoolEnrollment: offsetLimitPagination([
            'allSchools',
            'regionFias',
          ]),
          actionDivisions: offsetLimitPagination([
            'eventGroupSlug',
            'regionFias',
            'pastPerformanceOnly',
          ]),
          actionSpeakers: offsetLimitPagination([
            'eventGroupSlug',
            'regionFias',
            'pastPerformanceOnly',
            'divisionId',
          ]),
          eventsWithMeta: {
            keyArgs: [
              'startDateTime',
              'endDateTime',
              'promoted',
              'isOffline',
              'alternativeAddressFilter',
              'settlementId',
              'areaId',
              'regionId',
              'cityId',
              'ordering',
              'specialProjectSlug',
              'tagCategorySlugsTheme',
              'tagCategorySlugsDescribe',
              'macroTag',
              'active',
              'region',
              'speakersIds',
            ],
          },
          contentsByMicroTagsWithMeta: {
            keyArgs: [
              'themeTags',
              'describeTags',
              'tagCategorySlugsTheme',
              'tagCategorySlugsDescribe',
              'contentType',
              'speakersIds',
            ],
          },
          allCourses: relayStylePagination(),
          allApprovedActionDivisionRequests: offsetLimitPagination(),
        },
      },
      EventPhotoAlbumType: {
        fields: {
          photos: offsetLimitPagination(),
        },
      },
      EventItemType: {
        fields: {
          photos: offsetLimitPagination(),
        },
      },
      EventsWithMetaType: {
        fields: {
          events: offsetLimitPagination(),
        },
      },
      ContentWithMetaListType: {
        fields: {
          contents: offsetLimitPagination(),
        },
      },
      ContentWithMetaType: {
        fields: {
          contents: offsetLimitPagination(),
        },
      },
      TagCompilationBySlagWithMetaType: {
        fields: {
          tagCompilationBySlug: offsetLimitPagination(),
        },
      },
      TagsCompilationWithMetaType: {
        fields: {
          tagCompilations: offsetLimitPagination(),
        },
      },
      EventWithMetaType: {
        fields: {
          events: offsetLimitPagination(),
        },
      },
      TagsCompilationType: {
        keyFields: ['slug'],
      },
      PostTypeWithMeta: {
        fields: {
          results: offsetLimitPagination(),
        },
      },
      SpeechDetailsType: {
        keyFields: ['eventItemId'],
      },
      AddressType: {
        keyFields: ['fiasId'],
      },
    },
  });
